// extracted by mini-css-extract-plugin
module.exports = {"tag":"a2c79c7e7d--tag--Gj4bC","tag_content":"a2c79c7e7d--tag_content--EpMVE","tag_close":"a2c79c7e7d--tag_close--NT5sL"};